import { fetchToken } from '../fetchToken';
import axios from 'axios';
axios.defaults.withCredentials = true;
const API_URL = process.env.EMAILS_API_URL;
import { logError } from '../../taskpane/utils/request';

export const getSettings = async () => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: API_URL + 'settings',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (error) {
    logError(error);
    throw error;
  }
};
